import { render, staticRenderFns } from "./MemberCardTransactionDetail.vue?vue&type=template&id=08d0004a&scoped=true"
import script from "./MemberCardTransactionDetail.vue?vue&type=script&lang=js"
export * from "./MemberCardTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberCardTransactionDetail.vue?vue&type=style&index=0&id=08d0004a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0004a",
  null
  
)

export default component.exports